// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-close[data-v-263a0f86] {\n  position: relative;\n  cursor: pointer;\n}\n.icon-close .close-before[data-v-263a0f86] {\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  transform: rotate(45deg);\n}\n.icon-close .close-after[data-v-263a0f86] {\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  margin-top: -1px;\n  transform: rotate(-45deg);\n}\n", ""]);
// Exports
module.exports = exports;
